<router-outlet [@enterAnimation]></router-outlet>
<app-navigation-loader></app-navigation-loader>
@if (firstLoad$ | async) {
    <app-loading></app-loading>
}